
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogIn, User } from 'lucide-react';
import NavLink from './NavLink';
import NavListItem from './NavListItem';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDashboard } from '@/hooks/useDashboard';

const DesktopNav: React.FC = () => {
  const { userData, isAdmin, handleSignOut, isAuthCheckComplete } = useDashboard();
  const isAuthenticated = !!userData;

  return (
    <div className="hidden md:flex items-center space-x-8">
      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger className="text-itmgmt-dark-gray hover:text-itmgmt-medium-blue font-medium">Services</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
                <NavListItem href="/services/managed-it" title="Managed IT Services">
                  Comprehensive proactive support for your IT infrastructure
                </NavListItem>
                <NavListItem href="/services/cybersecurity" title="Cybersecurity">
                  Protect your business from evolving cyber threats
                </NavListItem>
                <NavListItem href="/services/network-infrastructure" title="Network & Infrastructure">
                  Build a reliable foundation for your business operations
                </NavListItem>
                <NavListItem href="/services/cloud-solutions" title="Cloud Solutions">
                  Leverage the power of cloud technology for flexibility
                </NavListItem>
                <NavListItem href="/services/project-consulting" title="Project Consulting">
                  Strategic guidance to align technology with objectives
                </NavListItem>
                <NavListItem href="/services/specialty-services" title="Specialty Services">
                  Unique solutions tailored to specific requirements
                </NavListItem>
                <NavListItem href="/services/residential" title="Residential IT Support">
                  Expert technology solutions for your home
                </NavListItem>
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
          
          <NavigationMenuItem>
            <NavLink sectionId="why-choose-us">
              Why Choose Us
            </NavLink>
          </NavigationMenuItem>
          
          <NavigationMenuItem>
            <NavLink sectionId="industries">
              Industries
            </NavLink>
          </NavigationMenuItem>
          
          <NavigationMenuItem>
            <Link to="/blog" className="text-itmgmt-dark-gray hover:text-itmgmt-medium-blue font-medium transition-colors block py-2 px-3">
              Blog
            </Link>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
      
      <Button asChild className="button-primary">
        <Link to="/book">Book a Consultation</Link>
      </Button>

      {isAuthCheckComplete && (
        isAuthenticated ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="text-itmgmt-dark-blue border-itmgmt-dark-blue hover:bg-itmgmt-medium-blue/10">
                <User className="mr-2 h-4 w-4" />
                {userData?.full_name || 'Account'}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              {isAdmin ? (
                <DropdownMenuItem asChild>
                  <Link to="/admin">Admin Dashboard</Link>
                </DropdownMenuItem>
              ) : (
                <DropdownMenuItem asChild>
                  <Link to="/dashboard">Dashboard</Link>
                </DropdownMenuItem>
              )}
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleSignOut}>
                Log Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <Button asChild variant="outline" className="text-itmgmt-dark-blue border-itmgmt-dark-blue hover:bg-itmgmt-medium-blue/10">
            <Link to="/auth"><LogIn className="mr-2 h-4 w-4" /> Login</Link>
          </Button>
        )
      )}
    </div>
  );
};

export default DesktopNav;
